import { render, staticRenderFns } from "./NewOCR.vue?vue&type=template&id=a7590d66&scoped=true&"
import script from "./NewOCR.vue?vue&type=script&lang=js&"
export * from "./NewOCR.vue?vue&type=script&lang=js&"
import style0 from "./NewOCR.vue?vue&type=style&index=0&id=a7590d66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7590d66",
  null
  
)

export default component.exports